<div class="modal fade" tabindex="-1" role="dialog" #audioPlayerDialog>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div #audioPlayer></div>
      </div>
    </div>
  </div>
</div>
